import { useMutation, useQueryClient } from '@tanstack/react-query';
import ChapterService from '../Services/chapters/ChapterService';
import { toast } from 'sonner';
import { GET_CHAPTERS_QUERY_KEY } from '../queries/useGetChapters';

export const useChapterMutations = () => {
  const queryClient = useQueryClient();

  const createChapterMutation = useMutation({
    mutationFn: ({ courseId, chaptersData }) => ChapterService.createNewChapters(courseId, chaptersData),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CHAPTERS_QUERY_KEY]);
      toast.success("Chapitre créé avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la création : ${error.message}`);
    },
  });

  const updateChapterMutation = useMutation({
    mutationFn: ({ id, data }) => ChapterService.updateChapterDetails(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CHAPTERS_QUERY_KEY]);
      toast.success("Chapitre mis à jour avec succès");
    },
    onError: (error) => {
      toast.error(`Échec de la mise à jour : ${error.message}`);
    },
  });

  const deleteChapterMutation = useMutation({
    mutationFn: (id) => ChapterService.deleteChapter(id),
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([GET_CHAPTERS_QUERY_KEY]);
        toast.success("Chapitre supprimé avec succès");
      } else {
        toast.error("Une erreur s'est produite lors de la suppression du chapitre.");
      }
    },
    onError: (error) => {
      toast.error(`Échec de la suppression : ${error.message}`);
    },
  });
  
  return {
    createChapterMutation,
    updateChapterMutation,
    deleteChapterMutation,
  };
};